import { render, staticRenderFns } from "./immediate-action-taken.vue?vue&type=template&id=5f4a6cb8&scoped=true"
import script from "./immediate-action-taken.vue?vue&type=script&lang=js"
export * from "./immediate-action-taken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4a6cb8",
  null
  
)

export default component.exports